import { registerModule } from "@/Registry";

export function initPwCleartext(element: Element): void {
  const toggle = element.querySelector<HTMLElement>("[data-ga-cleartextable-toggle]");
  const input = element.querySelector<HTMLInputElement>("input[type='password']");
  if (toggle === null || input === null) {
    return;
  }
  toggle.removeAttribute("hidden");

  toggle.addEventListener("click", () => {
    input.type = input.type === "password" ? "text" : "password";
    toggle.classList.toggle("ico-eye");
    toggle.classList.toggle("ico-eye-off");
  });
}

registerModule("[data-ga-cleartextable]", initPwCleartext);
